'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import FintechSectionThree from './components/FintechSectionThree'
import FiFromStrategy from './components/FiFromStrategy'
import SeamlessFinTech from './components/SeamlessFinTech'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'
import FinWhyChoose from './components/FinWhyChoose'

const faqData = [
   {
      question: 'What is FinTech software development, and why is it important?',
      answer:
         "It’s just building stuff that helps people deal with money online — like paying bills, checking balances, moving money around. Nothing fancy, just tools that make it less of a hassle. It’s important because everyone expects things to be fast, secure, and easy now. If you’re in finance, good software keeps you in the game and makes sure you're following the rules too.",
   },
   {
      question: 'How can FinTech software improve financial transactions?',
      answer:
         'FinTech software makes fast, secure, and automated financial transactions possible via AI-enabled fraud detection, integration of blockchain technology, and multiple-factor authentication and makes compliance achievable with financial compliances like PCI-DSS and GDPR.',
   },
   {
      question: 'What are the key features of a custom FinTech software solution?',
      answer: (
         <>
            <p className="faq-list-title m-0">A custom FinTech solution includes:</p>
            <ul className="faq-list">
               <li>Secure payment gateway integration</li>
               <li>AI-driven financial analytics</li>
               <li>Regulatory compliance automation</li>
               <li>Mobile banking & digital wallet support</li>
               <li>Fraud prevention and risk assessment</li>
            </ul>
         </>
      ),
   },
   {
      question: 'How do you ensure security in FinTech software development?',
      answer:
         'We introduce end-to-end encryption, fraud detection using artificial intelligence, biometric authentication, and blockchain-supported security to secure financial transactions and avoid cyber-attacks.',
   },
   {
      question: 'What types of businesses benefit from FinTech software solutions?',
      answer: (
         <>
            <p className="faq-list-title m-0">A FinTech software benefits:</p>
            <ul className="faq-list">
               <li>Banks & financial institutions (for seamless digital banking)</li>
               <li>E-commerce platforms (for secure payment gateways)</li>
               <li>Insurance companies (for automated claims processing)</li>
               <li>Investment firms (for AI-powered wealth management)</li>
               <li>Lending & mortgage companies (for instant loan approvals)</li>
            </ul>
         </>
      ),
   },
   {
      question: 'Do you develop mobile banking and digital wallet applications?',
      answer:
         'Yes, we work on mobile banking apps — stuff like real-time balance updates, insights driven by AI, and secure wallets using blockchain. We build this stuff to make money transfers and tracking easier. That’s really the point.',
   },
   {
      question: 'What are the advantages of integrating AI into FinTech solutions?',
      answer: (
         <>
            <p className="faq-list-title m-0">
               AI enhances FinTech software by providing:
            </p>
            <ul className="faq-list">
               <li>Automated fraud detection</li>
               <li>Real-time financial data analysis</li>
               <li>Personalized financial recommendations</li>
               <li>Predictive analytics for risk assessment</li>
            </ul>
         </>
      ),
   },
   {
      question: 'How does blockchain improve FinTech security?',
      answer:
         'Once it’s on the blockchain, it’s locked in. You can’t fake it or go back and change it. That’s why it’s solid for crypto and that whole space.',
   },
   {
      question: 'What is RegTech, and how can it help with compliance?',
      answer:
         "RegTech’s just tools that help companies not screw up compliance. Saves people time and avoids headaches. It automates stuff like reporting and rule checks so teams don’t have to do it all manually. Saves time, lowers mistakes, and helps with stuff like GDPR or PCI-DSS without stressing people out.",
   },
   {
      question:
         'How can I get started with a FinTech software development project?',
      answer:
         'It\'s simple to start! Reach out to us for a free consultation, and our FinTech professionals will evaluate your requirements, outline the optimal technology stack, and develop a secure, scalable, and tailored financial solution for your company.',
   },
];
 
function FintechPage() {
   useIndustriesNavbarScroll()

   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <FintechSectionThree />
         <FiFromStrategy />
         <SeamlessFinTech />
         <FinWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>
         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default FintechPage
